export { default } from './TaskInfoThread';
